import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"
import { visit } from "@hotwired/turbo"

const STALE_THRESHOLD_MS = 30_000
const HIDDEN_AT_KEY = "compoundHiddenAt"

export default class extends Controller {
  connect() {
    this.subscription = createConsumer().subscriptions.create("CompoundChannel", {})
    this.handleVisibilityChange = () => this.onVisibilityChange()
    this.handlePageShow = (e) => { if (e.persisted) this.refreshIfStale() }
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
    window.addEventListener("pageshow", this.handlePageShow)
    // Handle reconnect after JS suspension: visibility event may have already fired
    this.refreshIfStale()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
    window.removeEventListener("pageshow", this.handlePageShow)
  }

  onVisibilityChange() {
    if (document.visibilityState === "hidden") {
      sessionStorage.setItem(HIDDEN_AT_KEY, Date.now().toString())
    } else {
      this.refreshIfStale()
    }
  }

  refreshIfStale() {
    const hiddenAt = sessionStorage.getItem(HIDDEN_AT_KEY)
    if (!hiddenAt) return
    sessionStorage.removeItem(HIDDEN_AT_KEY)
    if (Date.now() - parseInt(hiddenAt) > STALE_THRESHOLD_MS) {
      visit(window.location.href, { action: "replace" })
    }
  }
}
